import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import BoardTransfer from "@/pages/BoardTransfer";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Admin from "@/pages/Admin";
import RoomsPage from "@/pages/RoomsPage";
import SurfLessons from "@/pages/SurfLessons";
import GuidePage from "@/pages/GuidePage";
import { applySeo, ROUTE_SEO } from "@/lib/seo";

const ScrollToHash = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 150);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const SeoManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/blog/")) return; // BlogPost sets its own SEO
    const seo = ROUTE_SEO[pathname];
    if (seo) applySeo(seo);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <SeoManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/board-transfer" element={<BoardTransfer />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/rooms" element={<RoomsPage />} />
          <Route path="/surf-lessons" element={<SurfLessons />} />
          <Route path="/guide" element={<GuidePage />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
